/**
 * Gift Card Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 */

// Configuration object
const config = {
  qrCode: '#QrCode',
  printButton: '#PrintGiftCard',
  giftCardCode: '.giftcard__code',
};

// Initialize QR code (uncomment if you have the QRCode library available)
// const qrCodeElement = document.querySelector(config.qrCode);
// new QRCode(qrCodeElement, {
//   text: qrCodeElement.getAttribute('data-identifier'),
//   width: 120,
//   height: 120,
// });

// Print button click event listener
document.querySelector(config.printButton).addEventListener('click', () => {
  window.print();
});

// Auto-select gift card code on click
document.querySelectorAll(config.giftCardCode).forEach((element) => {
  element.addEventListener('click', () => {
    selectText({
      data: { element: 'GiftCardDigits' },
    });
  });
});

// Function to select text based on element ID
function selectText(evt) {
  const text = document.getElementById(evt.data.element);
  let range = '';

  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();
  } else if (window.getSelection) {
    const selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}
